import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-add-new-tax',
  templateUrl: './add-new-tax.component.html',
  styleUrls: ['./add-new-tax.component.scss']
})
export class AddNewTaxComponent implements OnInit, OnDestroy {
  intTaxObj:any = {}
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
   entityHashId: string = ''
   loader:boolean = false
  panelState: any = [true, false, false, false, false,false];
  taxTypeform: FormGroup;
  taxValueform: FormGroup;
  taxObj: any = {
    
    tax_name: null,
    tax_desc: null,
   
    gstStatus: 0,
    cgstStatus: 0,
    igstStatus:  0,
    sgstStatus: 0,
    utgstStatus: 0,
    serviceTaxStatus: 0,
    otherTaxStatus:  0,
    gstNumber: null,
    sgstValue: null,
    cgstValue: null,
    igstValue: null,
    utgstValue: null,
    otherTax: null,
    otherTaxName: null,
    serviceTaxValue: 0
  }
  taxData:any = []
  _apiSubscription:Subscription
  constructor(
    private navservice:NavigationService,private fb: FormBuilder,
    private _apiservice:ApiService, private loaderservice: LoaderServiceService,private route: ActivatedRoute, private router: Router
  ) {     
    
    this.navservice.hideSidebarAndNav = false;

    this.taxTypeform = this.fb.group({
      types: this.fb.array([this.createItemForTaxType()])
    });
    this.taxValueform = this.fb.group({
      values: this.fb.array([this.createItemForTaxValue()])
    });


    this._apiSubscription = this._apiservice.apiResult.subscribe((resData) => {
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_TAX_DATA){
        this.router.navigate(['../'], {relativeTo: this.route, queryParamsHandling: 'preserve'})
        // this.parentData.ref.closeAll();
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_DATA){
        this.router.navigate(['../'], {relativeTo: this.route, queryParamsHandling: 'preserve'})
        // this.parentData.ref.closeAll();
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_SLABS_DATA){
        this.router.navigate(['../'], {relativeTo: this.route, queryParamsHandling: 'preserve'})
        // this.parentData.ref.closeAll();
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxData = []
        if(resData.result){
          this.taxData = resData.result
          this.taxData.forEach((element:any) => {
            element.isSelected = 0
          });
          this.taxData[0].isSelected = 1
          // this.taxObj.tanNumber = this.taxData[0].tanNumber
          this.taxObj.hash_id = this.taxData[0].hash_id
          this.taxObj.tax_name = this.taxData[0].tax_name
          this.taxObj.tax_desc = this.taxData[0].tax_desc
          this.taxObj.gstStatus = this.taxData[0].gst_status ? this.taxData[0].gst_status : 0
          this.taxObj.cgstStatus = this.taxData[0].cgst_status ? this.taxData[0].cgst_status : 0
          this.taxObj.igstStatus = this.taxData[0].igst_status ? this.taxData[0].igst_status : 0
          this.taxObj.sgstStatus = this.taxData[0].sgst_status ? this.taxData[0].sgst_status : 0
          this.taxObj.utgstStatus = this.taxData[0].utgst_status ? this.taxData[0].utgst_status : 0
          this.taxObj.serviceTaxStatus = this.taxData[0].service_tax_status ? this.taxData[0].service_tax_status : 0
          this.taxObj.otherTaxStatus = this.taxData[0].other_tax_status ? this.taxData[0].other_tax_status : 0
          this.taxObj.sgstValue = this.taxData[0].sgst_value
          this.taxObj.cgstValue = this.taxData[0].cgst_value
          this.taxObj.igstValue = this.taxData[0].igst_value
          this.taxObj.utgstValue = this.taxData[0].utgst_value
          this.taxObj.otherTax = this.taxData[0].other_tax
          this.taxObj.otherTaxName = this.taxData[0].other_tax_name
          this.taxObj.serviceTaxValue = this.taxData[0].service_tax_value
        }
        
        this.loaderservice.showLoader = false
        this.loader = false
      }

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_DATA){
        this.taxData = []
        if(resData.result){
          this.taxData.push(resData.result)
          this.taxData[0].tax_types = typeof this.taxData[0].tax_types == 'string' ? JSON.parse(this.taxData[0].tax_types) : this.taxData[0].tax_types 
          this.taxData[0].tax_values = typeof this.taxData[0].tax_values == 'string' ? JSON.parse(this.taxData[0].tax_values) : this.taxData[0].tax_values 

          if(this.taxData[0].tax_types){
            this.taxTypeform = this.fb.group({
              types: this.fb.array([])
            });
            this.taxData[0].tax_types.forEach((element:any) => {
              if(element){
                this.types.push(this.createFieldWithItemForTaxType(element));
              }
              // if(element.current_status == 3){
              // }
            });
          }
          if(this.taxData[0].tax_values){
            this.taxValueform = this.fb.group({
              values: this.fb.array([])
            });
            this.taxData[0].tax_values.forEach((element:any) => {
              if(element){
                this.values.push(this.createFieldWithItemForTaxValue(element));
              }
              // if(element.current_status == 3){
              // }
            });
          }
        }
        // else{
        //   this.toShowCheck = 0
        // }
        this.loaderservice.showLoader = false
        this.loader = false
      }
    })
  }

  get types(): FormArray {
    return this.taxTypeform.get('types') as FormArray;
  }
  get values(): FormArray {
    return this.taxValueform.get('values') as FormArray;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
    }) 

    // if(this.isEntityForeign == '0'){
      
    //       this.loaderservice.showLoader = true
    //       this.loader = true
    //       this._apiservice.getEntityTaxSlabData(this.entityHashId)

    // }
    // else if(this.isEntityForeign == '1'){
    //   this.loaderservice.showLoader = true
    //   this.loader = true
    //   this._apiservice.getInternationalEntityTaxData(this.entityHashId)
    // }
  }
  onToggleChange(event:any){
    
    if(event.checked){
      this.taxObj.gstStatus = 1
    }else if(!event.checked){
      this.taxObj.gstStatus = 0
      this.taxObj.cgstStatus = 0
      this.taxObj.igstStatus = 0
      this.taxObj.sgstStatus = 0
      this.taxObj.utgstStatus = 0
    }
  }
  onToggleChangeCGST(event:any){
    if(event.checked){
      this.taxObj.cgstStatus = 1
    }else if(!event.checked){
      this.taxObj.cgstStatus = 0
    }
  }
  onToggleChangeIGST(event:any){
    
    if(event.checked){
      this.taxObj.igstStatus = 1
    }else if(!event.checked){
      this.taxObj.igstStatus = 0
      
    }
  }
  onToggleChangeSGST(event:any){
    
    if(event.checked){
      this.taxObj.sgstStatus = 1
    }else if(!event.checked){
      this.taxObj.sgstStatus = 0
    }
  }
  onToggleChangeUTGST(event:any){
    
    if(event.checked){
      this.taxObj.utgstStatus = 1
    }else if(!event.checked){
      this.taxObj.utgstStatus = 0
    }
  }
  onToggleChangeServiceTax(event:any){
    
    if(event.checked){
      this.taxObj.serviceTaxStatus = 1
    }else if(!event.checked){
      this.taxObj.serviceTaxStatus = 0
      
    }
  }
  onToggleChangeOtherTax(event:any){
    
    if(event.checked){
      this.taxObj.otherTaxStatus = 1
    }else if(!event.checked){
      this.taxObj.otherTaxStatus = 0

      
    }
  }

  onSubmitTaxDetails(){

    let data = JSON.parse(JSON.stringify(this.taxObj))
    data.tax_collection_status = 1
    data.createdBy = data.editedBy = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    data.businessHashId = this.entityHashId
    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    // console.log(this.taxObj);
    console.log(data);
    this.loaderservice.showLoader = true
    this._apiservice.addEditEntityTaxData(data)
  }

  onReset(){
    this.taxObj = {
      tanNumber: null,
      panNumber: null,
      gstStatus: 0,
      cgstStatus: 0,
      igstStatus:  0,
      sgstStatus: 0,
      utgstStatus: 0,
      serviceTaxStatus: 0,
      otherTaxStatus:  0,
      gstNumber: null,
      sgstValue: null,
      cgstValue: null,
      igstValue: null,
      utgstValue: null,
      otherTax: null,
      otherTaxName: null,
      serviceTaxValue: 0
    }
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  // Add new form field
addTaxTypeField(): void {
  this.types.push(this.createItemForTaxType());
}
  // Add new form field
addTaxValueField(): void {
  this.values.push(this.createItemForTaxValue());
}

// Create a new form group for each item
itemOptions: string[] = ['Item1', 'Item2', 'Item3', 'Item4'];  // List of options
  filteredOptions: Observable<any[]>[] = [];
createItemForTaxType(): FormGroup {
  const itemGroup = this.fb.group({
    tax_type: ['', Validators.required],
    identification_no: ['', Validators.required],
  });

  return itemGroup;
  
}

createFieldWithItemForTaxType(item:any): FormGroup {
  const itemGroup = this.fb.group({
    tax_type: [item.taxation_type, Validators.required],
    identification_no: [item.identification_no, Validators.required],
  });

  return itemGroup;
}

createItemForTaxValue(): FormGroup {
  const itemGroup = this.fb.group({
    tax_name: ['', Validators.required],
    tax_value: ['', Validators.required],
  });

  return itemGroup;
  
}
createFieldWithItemForTaxValue(item:any): FormGroup {
  const itemGroup = this.fb.group({
    tax_name: [item.tax_name, Validators.required],
    tax_value: [item.tax_percentage, Validators.required],
  });

  return itemGroup;
  
}

// Remove a form field by index
removeFormFieldForTypes(index: number): void {
    
  this.types.removeAt(index);
}
// Remove a form field by index
removeFormFieldForValues(index: number): void {
    
  this.values.removeAt(index);
}


onSaveInternationalTax(){
  let obj = {
    
    "tax_slab_name": this.intTaxObj.slab_name,
    "tax_slab_desc": this.intTaxObj.slab_desc,
    "entity_hash": this.entityHashId,
    "tax_collection_status": 1,
    "tax_values": this.taxValueform.get('values')!.value.map((item:any) => {
      return {
        "tax_name": item.tax_name, 
        "tax_value": item.tax_value,
      }
    })
}

console.log(obj);

this.loaderservice.showLoader = true
this._apiservice.addEditInternationalEntityTaxSlabsData(obj)

}

onSelectChip(index:any){
  this.taxData.forEach((element:any) => {
    element.isSelected = 0
  });
  this.taxData[index].isSelected = 1

  this.taxObj.hash_id = this.taxData[index].hash_id
  this.taxObj.tax_name = this.taxData[index].tax_name
  this.taxObj.tax_desc = this.taxData[index].tax_desc
  this.taxObj.gstStatus = this.taxData[index].gst_status ? this.taxData[index].gst_status : 0
  this.taxObj.cgstStatus = this.taxData[index].cgst_status ? this.taxData[index].cgst_status : 0
  this.taxObj.igstStatus = this.taxData[index].igst_status ? this.taxData[index].igst_status : 0
  this.taxObj.sgstStatus = this.taxData[index].sgst_status ? this.taxData[index].sgst_status : 0
  this.taxObj.utgstStatus = this.taxData[index].utgst_status ? this.taxData[index].utgst_status : 0
  this.taxObj.serviceTaxStatus = this.taxData[index].service_tax_status ? this.taxData[index].service_tax_status : 0
  this.taxObj.otherTaxStatus = this.taxData[index].other_tax_status ? this.taxData[index].other_tax_status : 0
  this.taxObj.sgstValue = this.taxData[index].sgst_value
  this.taxObj.cgstValue = this.taxData[index].cgst_value
  this.taxObj.igstValue = this.taxData[index].igst_value
  this.taxObj.utgstValue = this.taxData[index].utgst_value
  this.taxObj.otherTax = this.taxData[index].other_tax
  this.taxObj.otherTaxName = this.taxData[index].other_tax_name
  this.taxObj.serviceTaxValue = this.taxData[index].service_tax_value


}


}
